// eslint-disable-next-line import/no-anonymous-default-export
export default [
  {
    url: "https://media.istockphoto.com/photos/ro/productivitate-sus%C8%9Binut%C4%83-de-tehnologia-digital%C4%83-id1330965067?s=612x612",
    name: "Lily-Rose Depp",
    age: "51",
  },
  {
    url: "https://media.istockphoto.com/photos/ro/productivitate-sus%C8%9Binut%C4%83-de-tehnologia-digital%C4%83-id1330965067?s=612x612",
    name: "Lily-Rose Depp",
    age: "51",
  },
  {
    url: "https://media.istockphoto.com/photos/ro/productivitate-sus%C8%9Binut%C4%83-de-tehnologia-digital%C4%83-id1330965067?s=612x612",
    name: "Lily-Rose Depp",
    age: "51",
  },
  {
    url: "https://media.istockphoto.com/photos/ro/productivitate-sus%C8%9Binut%C4%83-de-tehnologia-digital%C4%83-id1330965067?s=612x612",
    name: "Lily-Rose Depp",
    age: "51",
  },
  {
    url: "https://media.istockphoto.com/photos/ro/productivitate-sus%C8%9Binut%C4%83-de-tehnologia-digital%C4%83-id1330965067?s=612x612",
    name: "Lily-Rose Depp",
    age: "51",
  },
];
